<template>
  <div :class="{ horizontalDisplay: horizontalToggler }">
    <v-autocomplete
      v-for="(v, k) in filterParams"
      :key="k"
      v-model="resultParams[k]"
      :class="{ 'maxHeight50 col col-2': horizontalToggler }"
      :items="v.options"
      hide-no-data
      hide-selected
      item-text="Description"
      :item-value="v.name"
      :label="v.displayName"
      placeholder="Start typing to Search"
      :prepend-icon="prefixIcon"
      return-object
      clearable
      :disabled="disabled"
      @change="search"
    />
  </div>
</template>

<script>
import { isNil } from 'lodash';

export default {
  name: 'AdvancedFilter',
  props: {
    filterParams: { type: Object, default: () => ({}) },
    updatedParams: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    horizontalToggler: Boolean,
    prefixIcon: { type: String, default: 'mdi-database-search' },
    dropdownInitialValue: { type: String, default: '' },
  },
  data() {
    return {
      resultParams: {},
    };
  },
  computed: {},
  watch: {
    /**
    filter updated from external
    */
    updatedParams(now) {
      const corrosion = ['Clean', 'Light', 'Moderate', 'Heavy', 'Any'];
      if (now.length === 0) {
        this.resultParams = {};
        return;
      }
      for (const elem of now) {
        // format corrosion categories for display
        if (elem.key === 'metrics.corrosion_category') {
          this.$set(this.resultParams, elem.key, corrosion[elem.value]);
        } else {
          this.$set(this.resultParams, elem.key, elem.value);
        }
      }
    },

    dropdownInitialValue() {
      this.registerInitialValue();
    },
    filterParams() {
      // Hack to update selected item in dropdown
      // this.registerInitialValue();
    },
  },
  beforeMount() {
    this.registerInitialValue();
  },
  methods: {
    // filter updated internally
    search() {
      const corrosion = ['Clean', 'Light', 'Moderate', 'Heavy', 'Any'];
      const activeParams = [];
      const clearedParamKeys = [];
      for (const elem of Object.entries(this.resultParams)) {
        if (isNil(elem[1])) {
          clearedParamKeys.push(elem[0]);
        } else {
          // format corrosion categories for queries
          if (elem[0] === 'metrics.corrosion_category') {
            elem[1] = corrosion.indexOf(elem[1]);
          }
          activeParams.push({ key: elem[0], value: elem[1] });
        }
      }
      this.$emit('filter', activeParams, clearedParamKeys);
    },

    registerInitialValue() {
      Object.entries(this.filterParams).forEach(([element, { initialValue }]) => {
        this.resultParams[element] = initialValue;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.horizontalDisplay {
  display: flex;
  flex-direction: row;
}
.maxHeight50 {
  max-height: 50px;
}
</style>
